<template>
  <div class="comp-collect-pop">
    <tx-msg-box ref="collectMsg" class="user-ques-msg-box" @close="close" :options="{type: 'alert', title: '收藏试题', showClose: true, align: 'tl', confirmButtonText: '确定', confirmButtonClass: 'btn-primary', callback: bindCollectQues, callbackClose: true}">
      <div class="pt20 pb20 tc">
        收藏至：
        <el-select v-model="catalogID" placeholder="请选择">
          <el-option
            v-for="item in catalogList"
            :key="item.catalogID"
            :label="item.catalogName"
            :value="item.catalogID">
            {{item.catalogName}}
          </el-option>
        </el-select>
      </div>
    </tx-msg-box>
  </div>
</template>

<script>
  /*!*
   * @author yueheqin
   * @date 2019/7/18
   * @project zujuanzaixian
   * @desc 试题收藏
   */
  import {mapState, mapActions, mapGetters, mapMutations} from 'vuex'
  export default {
    name: 'comp-collect-pop',
    props: {},
    data () {
      return {
        catalogID: '0'
      }
    },
    computed: {
      ...mapState('pop', ['collectPopVisible', 'currentOprQues']),
      ...mapGetters('pop', ['correctType']),
      ...mapGetters('common', ['catalogList'])
    },
    watch: {
      'collectPopVisible': {
        handler (n, o) {
          if (n) {
            this.$nextTick(() => {
              this.open()
            })
          }
        },
        immediate: true
      },
      'catalogList': {
        handler (list, o) {
          if (list && list.length) {
            this.catalogID = list[0].catalogID
          }
        },
        immediate: true
      }
    },
    methods: {
      ...mapMutations('pop', ['updateCollectPopVisible', 'updateCurrentQues']),
      ...mapActions('common', ['collectQues', 'collectQuesCancel']),
      ...mapActions('zujuan', ['collectQues']),
      // 收藏试题
      bindCollectQues (type) {
        if (type === 'confirm') {
          if (this.catalogID === '') {
            this.$message.error('请选择要收藏到的文件夹')
            return false
          }
          let testID = this.currentOprQues.testID
          let payload = {
            data: {
              testID: testID,
              catalogID: this.catalogID
            },
            config: {
              loading: '#Ques' + testID
            }
          }
          this.collectQues(payload).then(res => {
            this.updateCurrentQues(_.assign(this.currentOprQues, {collectID: res.data.collectID}))
            this.$notify.success({
              title: '提示',
              message: res.data.msg
            })
            this.close()
            this.$refs.collectMsg.close()
          })
        }
      },
      open () {
        this.$refs.collectMsg.open()
      },
      close () {
        console.log('closeDialog')
        this.updateCollectPopVisible(false)
      }
    }
  }
</script>

<style lang="less">
  .comp-collect-pop {
  }
</style>
